module.exports = __webpack_public_path__ + "assets/img/chat.df3419d8.png";